import { getAreGatesPopulated, getIsUngatedForMarketingPlus } from 'pricing-pages-lib/utils/gatingUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const areGatesPopulatedSelector = createSelectorFromUtil(getAreGatesPopulated, transformState);
export const isUngatedForMarketingPlusSelector = createSelectorFromUtil(getIsUngatedForMarketingPlus, transformState);